import React, {Component} from "react";
import { Nav, NavItem, NavLink, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge, Button, ButtonGroup } from 'reactstrap';




class Help extends Component {
    render() {
        return (
            <div className="animated fadeIn">
                <div className="email-app mb-4">
                    <nav>
                        <Nav>
                            <NavItem>
                                <NavLink href="#/help"><i className="fa fa-inbox"></i> Navigation</NavLink>
                            </NavItem>
                        </Nav>
                    </nav>
                    <main className="inbox">
                        <ul className="messages">
                            <li className="message unread">
                                <div className="actions">
                                    <span className="action"><i className="fa fa-square-o"></i></span>
                                    <span className="action"><i className="fa fa-star-o"></i></span>
                                </div>
                                <div className="header">
                                    <span className="from">Navigation</span>
                                    <span className="date"><span className="fa fa-paper-clip"></span> Today, 3:47 PM</span>
                                </div>
                                <div className="title">
                                    Coming Soon
                                </div>
                                <div className="description">
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                                </div>
                            </li>

                        </ul>
                    </main>
                </div>
            </div>
        )
    }
}

export default Help;



// WEBPACK FOOTER //
// ./src/views/Help/Help.js